'use strict';

const { h } = require('phy');

const CouponsList = require('../../coupons/views/coupons-list-hoc');

function MainContent({ couponsForList, routes }) {
  return h(
    '',
    {
      'data-bhw': 'ExclusiveCouponsList',
    },
    h(CouponsList, { coupons: couponsForList, routes })
  );
}

module.exports = MainContent;
